import { useState, useEffect } from "react";
import {
  createIncident,
  updateIncident,
  sendIncident,
  deleteIncident,
} from "../../../api/incidents";
import { useNavigate } from "react-router-dom";
import { getLang } from "../../../store/uiStore";
import "./AdverseEventForm.css";


export default function AdverseEventForm({
  initialData = null,
  isEdit = false,
  isReadonly = false,
}) {
  const [incidentId, setIncidentId] = useState(initialData?.id || null);
  const [errors, setErrors] = useState({});

  const lang = getLang();

  const tr = {
    saved: lang === "ru" ? "Сохранено" : "Сабт шуд",
    sent: lang === "ru" ? "Отправлено" : "Фиристода шуд",
    updated: lang === "ru" ? "Обновлено" : "Навсозӣ шуд",
    deleted: lang === "ru" ? "Удалено" : "Нест карда шуд",

    title:
      lang === "ru"
        ? "Нежелательное явление"
        : "Ҳодисаи номатлуб",

    save:
      lang === "ru"
        ? "Сохранить"
        : "Сабт кардан",

    send:
      lang === "ru"
        ? "Отправить"
        : "Фиристодан",

    update:
      lang === "ru"
        ? "Обновить"
        : "Навсозӣ",

    remove:
      lang === "ru"
        ? "Удалить"
        : "Нест кардан",

    generalInfo:
      lang === "ru"
        ? "Общая информация"
        : "Маълумоти умумӣ",

    outcome:
      lang === "ru"
        ? "Исход"
        : "Натиҷа",

    recovered:
      lang === "ru"
        ? "Выздоровление без последствий"
        : "Шифо ёфт бе оқибат",

    recoveredWith:
      lang === "ru"
        ? "С последствиями"
        : "Бо оқибатҳо",

    additionalInfo:
      lang === "ru"
        ? "Дополнительная информация"
        : "Маълумоти иловагӣ",

    reactionDescription:
      lang === "ru"
        ? "Описание реакции"
        : "Тавсифи реаксия",

    suspectedDrug:
      lang === "ru"
        ? "Подозреваемое лекарственное средство"
        : "Доруи гумонбар",

    tradeName:
      lang === "ru"
        ? "Торговое название"
        : "Номи тиҷоратӣ",

    genericName:
      lang === "ru"
        ? "Генерическое название"
        : "Номи умумӣ",

    manufacturer:
      lang === "ru"
        ? "Производитель"
        : "Истеҳсолкунанда",

    batchNumber:
      lang === "ru"
        ? "Номер серии"
        : "Рақами серия",

    dosageForm:
      lang === "ru"
        ? "Лекарственная форма"
        : "Шакли дору",

    dailyDose:
      lang === "ru"
        ? "Суточная доза"
        : "Миқдори шабонарӯзӣ",

    singleDose:
      lang === "ru"
        ? "Разовая доза"
        : "Миқдори яккарата",

    drugName:
      lang === "ru"
        ? "Название препарата"
        : "Номи дору",

    drugForm:
      lang === "ru"
        ? "Лекарственная форма"
        : "Шакли дору",

    dose:
      lang === "ru"
        ? "Доза"
        : "Миқдор",

    frequency:
      lang === "ru"
        ? "Кратность"
        : "Басомад",

    route:
      lang === "ru"
        ? "Путь введения"
        : "Тарзи воридкунӣ",

    indication:
      lang === "ru"
        ? "Показания к назначению"
        : "Нишондод барои таъйин",

    reactionInfo:
      lang === "ru"
        ? "Информация о реакции"
        : "Маълумот дар бораи реаксия",

    previousReaction:
      lang === "ru"
        ? "Были ранее реакции на препарат"
        : "Пештар ба дору чунин реаксия буд",

    noDrugs:
      lang === "ru"
        ? "Нет добавленных препаратов"
        : "Доруи иловашуда нест",

    addDrug:
      lang === "ru"
        ? "+ Добавить препарат"
        : "+ Илова кардани дору",

    correction:
      lang === "ru"
        ? "Коррекция побочной реакции"
        : "Ислоҳи реаксияи номатлуб",

    drugStopped:
      lang === "ru"
        ? "Отмена подозреваемого ЛС привела к исчезновению реакции"
        : "Қатъи доруи гумонбар боиси аз байн рафтани реаксия шуд",

    reintroduced:
      lang === "ru"
        ? "Реакция повторилась при повторном назначении"
        : "Ҳангоми таъйини такрорӣ реаксия боз пайдо шуд",

    doseReduced:
      lang === "ru"
        ? "Реакция изменилась при снижении дозы"
        : "Ҳангоми кам кардани доза реаксия тағйир ёфт",

    correctionNotDone:
      lang === "ru"
        ? "Коррекция не проводилась"
        : "Ислоҳ гузаронида нашуд",

    concomitantStopped:
      lang === "ru"
        ? "Отмена сопутствующих ЛС (указать какие)"
        : "Қатъи доруҳои ҳамзамон (нишон диҳед кадомҳо)",

    treatmentGiven:
      lang === "ru"
        ? "Лечение реакции (препараты, дозы, длительность)"
        : "Табобати реаксия (доруҳо, доза, давомнокӣ)",

    causality:
      lang === "ru"
        ? "Причинно-следственная связь"
        : "Робитаи сабабӣ-натиҷавӣ",

    certain:
      lang === "ru"
        ? "Определённая"
        : "Муайян",

    probable:
      lang === "ru"
        ? "Вероятная"
        : "Эҳтимолӣ",

    possible:
      lang === "ru"
        ? "Возможная"
        : "Имконпазир",

    doubtful:
      lang === "ru"
        ? "Сомнительная"
        : "Шубҳанок",

    unclassified:
      lang === "ru"
        ? "Не классифицируется"
        : "Тасниф намешавад",

    reportDate:
      lang === "ru"
        ? "Дата заполнения"
        : "Санаи пуркунӣ",

    patientSection:
      lang === "ru"
        ? "Данные пациента"
        : "Маълумоти бемор",

    fio:
      lang === "ru"
        ? "ФИО"
        : "Ному насаб",

    age:
      lang === "ru"
        ? "Возраст"
        : "Синну сол",

    address:
      lang === "ru"
        ? "Адрес"
        : "Суроға",

    gender:
      lang === "ru"
        ? "Пол"
        : "Ҷинс",

    male:
      lang === "ru"
        ? "Мужской"
        : "Мард",

    female:
      lang === "ru"
        ? "Женский"
        : "Зан",

    diagnosisSection:
      lang === "ru"
        ? "Диагноз"
        : "Ташхис",

    primaryDiagnosis:
      lang === "ru"
        ? "Основной диагноз"
        : "Ташхиси асосӣ",

    secondaryDiagnosis:
      lang === "ru"
        ? "Сопутствующий диагноз"
        : "Ташхиси ҳамроҳ",

    reactionCategory:
      lang === "ru"
        ? "Категория реакции"
        : "Категорияи реаксия",

    death:
      lang === "ru"
        ? "Смерть"
        : "Марг",

    lifeThreat:
      lang === "ru"
        ? "Угроза жизни"
        : "Хатари ҳаёт",

    hospitalization:
      lang === "ru"
        ? "Госпитализация"
        : "Бистарӣ шудан",

    prolonged:
      lang === "ru"
        ? "Продление госпитализации"
        : "Тамдиди бистарӣ",

    disability:
      lang === "ru"
        ? "Инвалидность"
        : "Маъюбӣ",

    birthDefect:
      lang === "ru"
        ? "Врожденные дефекты"
        : "Нуқсонҳои модарзодӣ",

    enterFio:
      lang === "ru"
        ? "Введите ФИО пациента"
        : "Ному насаби беморро ворид кунед",

    enterAddress:
      lang === "ru"
        ? "Введите адрес"
        : "Суроғаро ворид кунед",

    enterAge:
      lang === "ru"
        ? "Введите возраст"
        : "Синну солро ворид кунед",

    selectGender:
      lang === "ru"
        ? "Выберите пол"
        : "Ҷинсро интихоб кунед",

    drugStartDate:
      lang === "ru"
        ? "Дата начала приема"
        : "Санаи оғози қабул",

    drugEndDate:
      lang === "ru"
        ? "Дата окончания приема"
        : "Санаи анҷоми қабул",

    reactionStartDate:
      lang === "ru"
        ? "Дата начала реакции"
        : "Санаи оғози реаксия",

    reactionEndDate:
      lang === "ru"
        ? "Дата окончания реакции"
        : "Санаи анҷоми реаксия",

    concomitantStartDate:
      lang === "ru"
        ? "Дата начала приема"
        : "Санаи оғози қабул",

    concomitantEndDate:
      lang === "ru"
        ? "Дата окончания приема"
        : "Санаи анҷоми қабул",

    drugDose:
      lang === "ru"
        ? "Доза"
        : "Миқдор",

    drugRoute:
      lang === "ru"
        ? "Способ введения"
        : "Тарзи истифода",
  };

  const [form, setForm] = useState({
    patient: {
      patient_name: "",
      patient_address: "",
      medical_card_number: "",
      age: "",
      gender: "",
      height: "",
      weight: "",
    },
    diagnosis: {
      primary: "",
      secondary: "",
    },
    reaction_general: {
      outcome: "",
      additional_info: "",
      description: "",
    },
    suspected_drug: {
      trade_name: "",
      generic_name: "",
      manufacturer: "",
      batch_number: "",
      dosage_form: "",
      daily_dose: "",
      single_dose: "",
      frequency: "",
      route: "",
      start_date: "",
      end_date: "",
      indication: "",
    },
    reaction: {
      start_date: "",
      end_date: "",
      category: [],
      description: "",
      previous_reaction: false,
    },
    concomitant_drugs: [],
    correction: {
      drug_stopped: false,
      reaction_disappeared: false,
      reintroduced: false,
      dose_reduced: false,
      correction_not_done: false,
      concomitant_stopped: "",
      treatment_given: "",
    },
    causality: "",
    report: {
      date: "",
    },
  });

  const addDrug = () => {
    if (isReadonly) return;

    setForm((prev) => ({
      ...prev,
      concomitant_drugs: [
        ...prev.concomitant_drugs,
        {
          name: "",
          form: "",
          dose: "",
          frequency: "",
          route: "",
          start_date: "",
          end_date: "",
        },
      ],
    }));
  };

  const updateDrug = (index, field, value) => {
    if (isReadonly) return;

    const updated = [...form.concomitant_drugs];
    updated[index][field] = value;

    setForm((prev) => ({
      ...prev,
      concomitant_drugs: updated,
    }));
  };

  const removeDrug = (index) => {
    if (isReadonly) return;

    const updated = form.concomitant_drugs.filter((_, i) => i !== index);

    setForm((prev) => ({
      ...prev,
      concomitant_drugs: updated,
    }));
  };

  useEffect(() => {
    if (initialData) {
      setForm(initialData.data);
    }
  }, [initialData]);

  const handleChange = (section, field, value) => {
    if (isReadonly) return;

    setForm((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleRootChange = (field, value) => {
    if (isReadonly) return;

    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMulti = (value) => {
    if (isReadonly) return;

    setForm((prev) => {
      const exists = prev.reaction.category.includes(value);
      return {
        ...prev,
        reaction: {
          ...prev.reaction,
          category: exists
            ? prev.reaction.category.filter((v) => v !== value)
            : [...prev.reaction.category, value],
        },
      };
    });
  };

  const validate = () => {
    const e = {};

    if (!form.patient.patient_name)
      e.patient_name = tr.enterFio;

    if (!form.patient.patient_address)
      e.patient_address = tr.enterAddress;

    if (!form.patient.age) e.age = tr.enterAge;

    if (!form.patient.gender) e.gender = tr.selectGender;

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const navigate = useNavigate();

  const save = async () => {
    const payload = { type: "adverse_event", data: form };

    if (incidentId) {
      await updateIncident(incidentId, payload);
    } else {
      const res = await createIncident(payload);
      setIncidentId(res.data.id);

      // 🔥 переход в режим редактирования
      navigate(`/incidents/${res.data.id}`);
    }

    alert(tr.saved);
  };

  const send = async () => {
    if (!validate()) return;

    const payload = { type: "adverse_event", data: form };

    if (incidentId) {
      await updateIncident(incidentId, payload);
      await sendIncident(incidentId);

      navigate(`/incidents/${incidentId}`);
    } else {
      const res = await createIncident(payload);
      await sendIncident(res.data.id);

      navigate(`/incidents/${res.data.id}`);
    }

    alert(tr.sent);
  };

  const remove = async () => {
    if (!incidentId) return;

    await deleteIncident(incidentId);

    alert(tr.deleted);

    navigate("/incidents");
  };

  return (
    <div style={styles.container} className="nizom-adverse-event-form">
      <h2>{tr.title}</h2>

      {/* 🧍 Пациент */}
      <div style={styles.section}>
        <h3>{tr.patientSection}</h3>

        <div style={styles.row}>
          <input
            placeholder={tr.fio}
            value={form.patient.patient_name}
            onChange={(e) =>
              handleChange("patient", "patient_name", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />
          <input
            placeholder={tr.age}
            value={form.patient.age}
            onChange={(e) =>
              handleChange("patient", "age", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />
        </div>

        <input
          placeholder={tr.address}
          value={form.patient.patient_address}
          onChange={(e) =>
            handleChange("patient", "patient_address", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <select
          value={form.patient.gender}
          onChange={(e) =>
            handleChange("patient", "gender", e.target.value)
          }
          disabled={isReadonly}
          style={styles.input}
        >
          <option value="">{tr.gender}</option>
          <option value="male">{tr.male}</option>
          <option value="female">{tr.female}</option>
        </select>

        {errors.patient_name && <div style={styles.error}>{errors.patient_name}</div>}
        {errors.patient_address && <div style={styles.error}>{errors.patient_address}</div>}
        {errors.age && <div style={styles.error}>{errors.age}</div>}
        {errors.gender && <div style={styles.error}>{errors.gender}</div>}
      </div>

      {/* 📋 Диагноз */}
      <div style={styles.section}>
        <h3>{tr.diagnosisSection}</h3>
        <textarea
          placeholder={tr.primaryDiagnosis}
          value={form.diagnosis.primary}
          onChange={(e) =>
            handleChange("diagnosis", "primary", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />
        <textarea
          placeholder={tr.secondaryDiagnosis}
          value={form.diagnosis.secondary}
          onChange={(e) =>
            handleChange("diagnosis", "secondary", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />
      </div>

      {/* ⚠️ Категории */}
      <div style={styles.section}>
        <h3>{tr.reactionCategory}</h3>

        {[
          { value: "death", label: tr.death },
          { value: "life_threat", label: tr.lifeThreat },
          { value: "hospitalization", label: tr.hospitalization },
          { value: "prolonged", label: tr.prolonged },
          { value: "disability", label: tr.disability },
          { value: "birth_defect", label: tr.birthDefect },
        ].map((c) => (
          <label key={c.value} style={styles.checkbox}>
            <input
              type="checkbox"
              checked={form.reaction.category.includes(c.value)}
              onChange={() => handleMulti(c.value)}
              disabled={isReadonly}
            />
            {c.label}
          </label>
        ))}
      </div>

      {/* 📊 Общая информация о реакции */}
      <div style={styles.section}>
        <h3>{tr.generalInfo}</h3>

        <select
          value={form.reaction_general.outcome}
          onChange={(e) =>
            handleChange("reaction_general", "outcome", e.target.value)
          }
          disabled={isReadonly}
          style={styles.input}
        >
          <option value="">{tr.outcome}</option>
          <option value="recovered">{tr.recovered}</option>
          <option value="recovered_with">{tr.recoveredWith}</option>
        </select>

        <textarea
          placeholder={tr.additionalInfo}
          value={form.reaction_general.additional_info}
          onChange={(e) =>
            handleChange("reaction_general", "additional_info", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />

        <textarea
          placeholder={tr.reactionDescription}
          value={form.reaction_general.description}
          onChange={(e) =>
            handleChange("reaction_general", "description", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />
      </div>

      {/* 💊 Подозреваемое лекарство */}
      <div style={styles.section}>
        <h3>{tr.suspectedDrug}</h3>

        <input
          placeholder={tr.tradeName}
          value={form.suspected_drug.trade_name}
          onChange={(e) =>
            handleChange("suspected_drug", "trade_name", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <input
          placeholder={tr.genericName}
          value={form.suspected_drug.generic_name}
          onChange={(e) =>
            handleChange("suspected_drug", "generic_name", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <input
          placeholder={tr.manufacturer}
          value={form.suspected_drug.manufacturer}
          onChange={(e) =>
            handleChange("suspected_drug", "manufacturer", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <input
          placeholder={tr.batchNumber}
          value={form.suspected_drug.batch_number}
          onChange={(e) =>
            handleChange("suspected_drug", "batch_number", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <div style={styles.row}>
          <input
            placeholder={tr.dosageForm}
            value={form.suspected_drug.dosage_form}
            onChange={(e) =>
              handleChange("suspected_drug", "dosage_form", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />

          <input
            placeholder={tr.dailyDose}
            value={form.suspected_drug.daily_dose}
            onChange={(e) =>
              handleChange("suspected_drug", "daily_dose", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />
        </div>

        <div style={styles.row}>
          <input
            placeholder={tr.singleDose}
            value={form.suspected_drug.single_dose}
            onChange={(e) =>
              handleChange("suspected_drug", "single_dose", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />

          <input
            placeholder={tr.frequency}
            value={form.suspected_drug.frequency}
            onChange={(e) =>
              handleChange("suspected_drug", "frequency", e.target.value)
            }
            disabled={isReadonly}
            style={styles.input}
          />
        </div>

        <input
          placeholder={tr.route}
          value={form.suspected_drug.route}
          onChange={(e) =>
            handleChange("suspected_drug", "route", e.target.value)
          }
          disabled={isReadonly}
          style={styles.inputFull}
        />

        <div style={styles.row}>
          <div style={{ flex: 1 }}>
            <label style={styles.label}>
              {tr.drugStartDate}
            </label>

            <input
              type="date"
              value={form.suspected_drug.start_date}
              onChange={(e) =>
                handleChange(
                  "suspected_drug",
                  "start_date",
                  e.target.value
                )
              }
              disabled={isReadonly}
              style={styles.input}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label style={styles.label}>
              {tr.drugEndDate}
            </label>

            <input
              type="date"
              value={form.suspected_drug.end_date}
              onChange={(e) =>
                handleChange(
                  "suspected_drug",
                  "end_date",
                  e.target.value
                )
              }
              disabled={isReadonly}
              style={styles.input}
            />
          </div>
        </div>

        <textarea
          placeholder={tr.indication}
          value={form.suspected_drug.indication}
          onChange={(e) =>
            handleChange("suspected_drug", "indication", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />
      </div>

      {/* 🧬 Реакция */}
      <div style={styles.section}>
        <h3>{tr.reactionInfo}</h3>

        <div style={styles.row}>
          <div style={{ flex: 1 }}>
            <label style={styles.label}>
              {tr.reactionStartDate}
            </label>

            <input
              type="date"
              value={form.reaction.start_date}
              onChange={(e) =>
                handleChange(
                  "reaction",
                  "start_date",
                  e.target.value
                )
              }
              disabled={isReadonly}
              style={styles.input}
            />
          </div>

          <div style={{ flex: 1 }}>
            <label style={styles.label}>
              {tr.reactionEndDate}
            </label>

            <input
              type="date"
              value={form.reaction.end_date}
              onChange={(e) =>
                handleChange(
                  "reaction",
                  "end_date",
                  e.target.value
                )
              }
              disabled={isReadonly}
              style={styles.input}
            />
          </div>
        </div>

        <textarea
          placeholder={tr.reactionDescription}
          value={form.reaction.description}
          onChange={(e) =>
            handleChange("reaction", "description", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />

        <label>
          <input
            type="checkbox"
            checked={form.reaction.previous_reaction}
            onChange={(e) =>
              handleChange("reaction", "previous_reaction", e.target.checked)
            }
            disabled={isReadonly}
          />
          {tr.previousReaction}
        </label>
      </div>

      {/* 💊 Сопутствующие лекарственные средства */}
      <div style={styles.section}>
        <h3>{tr.concomitantDrugs}</h3>

        {form.concomitant_drugs.length === 0 && (
          <div style={{ marginBottom: "10px", color: "#777" }}>
            {tr.noDrugs}
          </div>
        )}

        {form.concomitant_drugs.map((drug, index) => (
          <div key={index} style={styles.drugCard}>
            <div style={styles.row}>
              <input
                placeholder={tr.drugName}
                value={drug.name}
                onChange={(e) =>
                  updateDrug(index, "name", e.target.value)
                }
                disabled={isReadonly}
                style={styles.input}
              />

              <input
                placeholder={tr.drugForm}
                value={drug.form}
                onChange={(e) =>
                  updateDrug(index, "form", e.target.value)
                }
                disabled={isReadonly}
                style={styles.input}
              />
            </div>

            <div style={styles.row}>
              <input
                placeholder={tr.dose}
                value={drug.dose}
                onChange={(e) =>
                  updateDrug(index, "dose", e.target.value)
                }
                disabled={isReadonly}
                style={styles.input}
              />

              <input
                placeholder={tr.frequency}
                value={drug.frequency}
                onChange={(e) =>
                  updateDrug(index, "frequency", e.target.value)
                }
                disabled={isReadonly}
                style={styles.input}
              />
            </div>

            <input
              placeholder={tr.route}
              value={drug.route}
              onChange={(e) =>
                updateDrug(index, "route", e.target.value)
              }
              disabled={isReadonly}
              style={styles.inputFull}
            />

            <div style={styles.row}>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>
                  {tr.concomitantStartDate}
                </label>

                <input
                  type="date"
                  value={drug.start_date}
                  onChange={(e) =>
                    updateDrug(
                      index,
                      "start_date",
                      e.target.value
                    )
                  }
                  disabled={isReadonly}
                  style={styles.input}
                />
              </div>

              <div style={{ flex: 1 }}>
                <label style={styles.label}>
                  {tr.concomitantEndDate}
                </label>

                <input
                  type="date"
                  value={drug.end_date}
                  onChange={(e) =>
                    updateDrug(
                      index,
                      "end_date",
                      e.target.value
                    )
                  }
                  disabled={isReadonly}
                  style={styles.input}
                />
              </div>
            </div>

            {!isReadonly && (
              <button
                onClick={() => removeDrug(index)}
                style={styles.deleteBtn}
              >
                {tr.remove}
              </button>
            )}
          </div>
        ))}

        {!isReadonly && (
          <button onClick={addDrug} style={styles.addBtn}>
            {tr.addDrug}
          </button>
        )}
      </div>

      {/* 🩺 Коррекция побочной реакции */}
      <div style={styles.section}>
        <h3>{tr.correction}</h3>

        <label style={styles.checkbox}>
          <input
            type="checkbox"
            checked={form.correction.drug_stopped}
            onChange={(e) =>
              handleChange("correction", "drug_stopped", e.target.checked)
            }
            disabled={isReadonly}
          />
          {tr.drugStopped}
        </label>

        <label style={styles.checkbox}>
          <input
            type="checkbox"
            checked={form.correction.reintroduced}
            onChange={(e) =>
              handleChange("correction", "reintroduced", e.target.checked)
            }
            disabled={isReadonly}
          />
          {tr.reintroduced}
        </label>

        <label style={styles.checkbox}>
          <input
            type="checkbox"
            checked={form.correction.dose_reduced}
            onChange={(e) =>
              handleChange("correction", "dose_reduced", e.target.checked)
            }
            disabled={isReadonly}
          />
          {tr.doseReduced}
        </label>

        <label style={styles.checkbox}>
          <input
            type="checkbox"
            checked={form.correction.correction_not_done}
            onChange={(e) =>
              handleChange("correction", "correction_not_done", e.target.checked)
            }
            disabled={isReadonly}
          />
          {tr.correctionNotDone}
        </label>

        <textarea
          placeholder={tr.concomitantStopped}
          value={form.correction.concomitant_stopped}
          onChange={(e) =>
            handleChange("correction", "concomitant_stopped", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />

        <textarea
          placeholder={tr.treatmentGiven}
          value={form.correction.treatment_given}
          onChange={(e) =>
            handleChange("correction", "treatment_given", e.target.value)
          }
          disabled={isReadonly}
          style={styles.textarea}
        />
      </div>

      {/* 🔗 Причинно-следственная связь */}
      <div style={styles.section}>
        <h3>{tr.causality}</h3>

        {[
          { value: "certain", label: tr.certain },
          { value: "probable", label: tr.probable },
          { value: "possible", label: tr.possible },
          { value: "doubtful", label: tr.doubtful },
          { value: "unclassified", label: tr.unclassified },
        ].map((item) => (
          <label key={item.value} style={styles.checkbox}>
            <input
              type="radio"
              name="causality"
              checked={form.causality === item.value}
              onChange={() => handleRootChange("causality", item.value)}
              disabled={isReadonly}
            />
            {item.label}
          </label>
        ))}
      </div>

      {/* 📅 Дата */}
      <div style={styles.section}>
        <h3>{tr.reportDate}</h3>
        <input
          type="date"
          value={form.report.date}
          onChange={(e) =>
            handleChange("report", "date", e.target.value)
          }
          disabled={isReadonly}
          style={styles.input}
        />
      </div>

      {/* 🔘 КНОПКИ */}
      {!isReadonly && (
        <div style={styles.buttons}>
          {!incidentId && (
            <>
              <button onClick={save}>{tr.save}</button>
              <button onClick={send}>{tr.send}</button>
            </>
          )}

          {incidentId && (
            <>
              <button onClick={save}>{tr.update}</button>
              <button onClick={send}>{tr.send}</button>
              <button onClick={remove} style={styles.deleteBtn}>
                {tr.remove}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { width: "100%", padding: "20px" },

  section: {
    background: "#fff",
    padding: "20px",
    marginBottom: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },

  row: { display: "flex", gap: "10px" },

  input: {
    flex: 1,
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },

  inputFull: {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },

  textarea: {
    width: "100%",
    minHeight: "80px",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginBottom: "10px",
  },

  checkbox: {
    display: "block",
    marginBottom: "5px",
  },

  buttons: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
  },

  error: {
    color: "red",
    fontSize: "12px",
  },

  drugCard: {
    border: "1px solid #eee",
    padding: "15px",
    marginBottom: "10px",
    borderRadius: "8px",
  },

  addBtn: {
    marginTop: "10px",
    padding: "10px",
    background: "#2d7ff9",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },

  deleteBtn: {
    marginTop: "10px",
    padding: "6px 10px",
    background: "#ff4d4f",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};
